var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListeningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#EEF2FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19180_96422",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19180_96422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 25.2708V23.5625C20.9167 23.2014 21.9236 22.5069 22.6875 21.4792C23.4514 20.4514 23.8333 19.2847 23.8333 17.9792C23.8333 16.6736 23.4514 15.5069 22.6875 14.4792C21.9236 13.4514 20.9167 12.7569 19.6667 12.3958V10.6875C21.3889 11.0764 22.7917 11.9479 23.875 13.3021C24.9583 14.6562 25.5 16.2153 25.5 17.9792C25.5 19.7431 24.9583 21.3021 23.875 22.6562C22.7917 24.0104 21.3889 24.8819 19.6667 25.2708ZM10.5 20.5V15.5H13.8333L18 11.3333V24.6667L13.8333 20.5H10.5ZM19.6667 21.3333V14.625C20.3194 14.9306 20.8299 15.3889 21.1979 16C21.566 16.6111 21.75 17.2778 21.75 18C21.75 18.7083 21.566 19.3646 21.1979 19.9688C20.8299 20.5729 20.3194 21.0278 19.6667 21.3333ZM16.3333 15.375L14.5417 17.1667H12.1667V18.8333H14.5417L16.3333 20.625V15.375Z",
    fill: "#133F7D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListeningIcon);
export default __webpack_public_path__ + "static/media/listening-icon.42333e99ff0946b59c783bb50f9b0cca.svg";
export { ForwardRef as ReactComponent };